import AppModules from '../../../core/app-modules';
import Loader from '../../../common/loader';
import Breadcrumbs from '../../../common/bread-crump/bread-crumb';
import { useCustomerPortalGlobalStore } from '../../../stores/customer-portal-global-store';
import { IRoute } from '../../../models/routes.interface';
import './body.scss';

export default function Body() {
  const [selectedMenu] = useCustomerPortalGlobalStore(
    store => store.menu.selectedMenu
  );
  const [isLoading] = useCustomerPortalGlobalStore(
    store => store.menu.isLoading
  );

  const routes: IRoute[] = Array.isArray(selectedMenu)
    ? (selectedMenu as IRoute[])
    : [];

  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <>
          <Breadcrumbs />
          <div className="grc-card-body">{<AppModules />}</div>
        </>
      )}
    </>
  );
}
